module.exports = __webpack_public_path__ + "files/limoges.783d1fb6130a7d2ce12bffb354d7c65c.pdf";